module.exports = __webpack_public_path__ + "img/map_entree.184924f8.png";